import styled, { css, FlattenSimpleInterpolation } from 'styled-components';

import { Breakpoint, Color, FontWeight } from '../../enums';
import { StyledComponent } from '../../interfaces';

import { ImageButtonProps, RightColumnProps } from './collectionSection.types';

const imageContainerStyle: FlattenSimpleInterpolation = css`
  overflow: hidden;
  position: relative;
`;

export const Container: StyledComponent<'div'> = styled.div`
  display: flex;
  height: 826px;
  width: 100%;

  @media ${Breakpoint.Tablet} {
    height: 514px;
  }

  @media ${Breakpoint.Mobile} {
    flex-direction: column;
    height: auto;
  }
`;

export const LeftColumn: StyledComponent<'div'> = styled.div`
  ${imageContainerStyle}
  width: 40%;
  height: 100%;
  

  @media ${Breakpoint.Mobile} {
    width: 100%;
    height: 332px;
  }

  @media ${Breakpoint.SmallMobile} {
    height: 380px;
  }
`;

export const RightColumn: StyledComponent<'div', RightColumnProps> = styled.div<RightColumnProps>`
  width: ${({ $fullWidth }: RightColumnProps): string => $fullWidth ? '100%' : '60%'};
  height: 100%;

  ${LeftColumn} + & {
    margin-left: 10px;

    @media ${Breakpoint.Mobile} {
      margin-left: 0;
      margin-top: 10px;
    }
  }

  @media ${Breakpoint.Mobile} {
    width: 100%;
  }

  @media ${Breakpoint.SmallMobile} {
    display: flex;
  }
`;

export const Row: StyledComponent<'div'> = styled.div`
  display: flex;
  height: calc(50% - 5px);

  & + & {
    margin-top: 10px;
  }

  @media ${Breakpoint.Mobile} {
    height: 332px;
  }
`;

export const Column: StyledComponent<'div'> = styled.div`
  width: calc(50% - 5px);
  height: 530px;
  
  & + & {
    margin-left: 10px;
  }
`;

export const BiggerImage: StyledComponent<'div'> = styled.div`
  ${imageContainerStyle}
  width: 60%;
  height: 100%;

  @media ${Breakpoint.SmallMobile} {
    width: 100%;
    height: 60%;
  }
`;

export const SmallerImage: StyledComponent<'div'> = styled.div`
  ${imageContainerStyle}
  width: 40%;
  height: 100%;
  
  & + ${BiggerImage},
  ${BiggerImage} + & {
    margin-left: 10px;

    @media ${Breakpoint.SmallMobile} {
      margin-left: 0;
      margin-top: 10px;
    }
  }

  @media ${Breakpoint.SmallMobile} {
    width: 100%;
    height: 40%;
  }
`;

export const ImageButton: StyledComponent<'button', ImageButtonProps> = styled.button.attrs<ImageButtonProps>({ type: 'button' })`
  background-image: url(${({ $backgroundImage }: ImageButtonProps): string => $backgroundImage});
  background-size: cover;
  background-repeat: no-repeat;
  background-position: center;
  transition: .3s;
  width: 100%;
  height: 100%;
  display: flex;
  align-items: flex-end;

  &:hover {
    transform: scale(1.2);

    @media ${Breakpoint.Mobile} {
      transform: none;
    }
  }
`;

export const ImageLabel: StyledComponent<'div'> = styled.div`
  font-weight: ${FontWeight.Medium};
  font-size: 18px;
  line-height: 26px;
  color: ${Color.White};
  background: linear-gradient(0deg, rgba(0, 0, 0, 0.4) 0%, rgba(0, 0, 0, 0.1) 50.95%, rgba(0, 0, 0, 0) 100%);
  height: 150px;
  width: 100%;
  padding: 24px;
  display: flex;
  align-items: flex-end;
  position: absolute;
  bottom: 0;
  left: 0;
  pointer-events: none;

  @media ${Breakpoint.Mobile} {
    padding: 20px;
  }

  @media ${Breakpoint.SmallMobile} {
    font-size: 16px;
    line-height: 22px;
    font-weight: ${FontWeight.Regular};
  }
`;
